import { useCallback } from "react";

import { useSetAtom } from "jotai";
import { v4 as uuid } from "uuid";

import { type GetSalesReportV3Augmented_me_salesTableReportV3Augmented_queryMetadata } from "@north-beam/nb-client-side";

import { queryMetadataAtom } from "./atoms";

interface Args {
  context: string;
  topic: string;
  metadata: GetSalesReportV3Augmented_me_salesTableReportV3Augmented_queryMetadata;
}

export const useQueryMetadata = () => {
  const setQueryMetadata = useSetAtom(queryMetadataAtom);

  const addQueryMetadata = useCallback(
    ({ context, topic, metadata }: Args) => {
      setQueryMetadata((prev) => [
        ...prev,
        ...metadata.bqLogs.map((log) => ({ id: uuid(), context, topic, log })),
      ]);
    },
    [setQueryMetadata],
  );

  return { addQueryMetadata };
};
